// 알림톡 대량 발송 관련 상수

/** 페이지 타이틀 */
export const ALIMTALK_PAGE_NAME = {
  SEND_CREATE: '알림톡 발송 등록',
} as const;

/** CSV 업로드 한도 (백엔드 검증과 일치) */
export const ALIMTALK_CSV_LIMIT = {
  /** 30MB */
  MAX_FILE_SIZE_BYTE: 30 * 1024 * 1024,
  /** 최대 대상 행 수 */
  MAX_ROW_COUNT: 300_000,
} as const;

/** presigned PUT 고정 ContentType */
export const ALIMTALK_CSV_CONTENT_TYPE = 'text/csv';

/**
 * CSV presigned PUT 타임아웃(ms).
 * axios 기본값 0(무제한)이면 업로드가 멈췄을 때 "업로드 중…" 상태로 폼이 잠긴 채 방치된다.
 * 최대 30MB 기준 저속 회선도 통과할 만큼 넉넉히 잡되, 이보다 오래 걸리면 실패로 간주해 재시도를 유도한다.
 */
export const ALIMTALK_CSV_UPLOAD_TIMEOUT_MS = 5 * 60 * 1000;

/** 버튼 URL/메시지의 기획전 ID 플레이스홀더 */
export const ALIMTALK_EVENT_ID_PLACEHOLDER = '{{eventId}}';

/**
 * 만료 유형 couponList의 issuedCount.
 * 발급이 아니지만 백엔드 DTO가 @Min(1)을 만료 포함 전 유형에 강제 — 만료 플로우에서 수량은 워커가 사용하지 않는다.
 */
export const ALIMTALK_EXPIRE_ISSUED_COUNT = 1;
